import { useEffect } from 'react';
import { ArrowLeft, RefreshCw } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const RefundPolicyPage = () => {
  const navigate = useNavigate();
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen bg-[#FDFBF7]" data-testid="refund-policy-page">
      <header className="sticky top-0 z-50 glass border-b border-[#2D231E]/10">
        <div className="container-max flex items-center h-16">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-[#5C4D43] hover:text-[#C44536] transition-colors"
            data-testid="back-from-refund"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-sans text-sm font-medium">Volver</span>
          </button>
        </div>
      </header>

      <div className="container-max py-12 max-w-4xl">
        <div className="flex items-center gap-3 mb-8">
          <RefreshCw className="w-8 h-8 text-[#C44536]" />
          <h1 className="font-serif text-3xl md:text-4xl font-bold text-[#2D231E]">Politica de Reembolsos y Cancelaciones</h1>
        </div>

        <div className="prose prose-lg font-sans text-[#2D231E] space-y-6">
          <p className="text-[#5C4D43] text-sm">Ultima actualizacion: Abril 2026</p>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">1. Derecho de Desistimiento: Excepcion Aplicable</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              De conformidad con el articulo 103.d) del Real Decreto Legislativo 1/2007, de 16 de noviembre,
              por el que se aprueba el texto refundido de la Ley General para la Defensa de los Consumidores y
              Usuarios (LGDCU), <strong>el derecho de desistimiento no es aplicable a los pedidos de comida
              preparada</strong>, al tratarse del suministro de bienes que pueden deteriorarse o caducar con
              rapidez.
            </p>
            <p className="text-[#5C4D43] leading-relaxed mt-3">
              Por ello, una vez aceptado el pedido por el restaurante e iniciada su preparacion, no es posible
              cancelar ni solicitar devolucion salvo en los supuestos descritos a continuacion.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">2. Cancelacion por el Cliente</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              El cliente puede cancelar su pedido <strong>durante los primeros 5 minutos</strong> desde la
              realizacion del mismo, siempre que el restaurante no haya aceptado todavia la preparacion.
              Transcurrido ese plazo o una vez aceptado el pedido por el restaurante, el pedido no podra ser
              cancelado por el cliente.
            </p>
            <p className="text-[#5C4D43] leading-relaxed mt-3">
              Para cancelaciones dentro de ese plazo, los pagos realizados online seran reembolsados
              automaticamente al mismo medio de pago utilizado en un plazo maximo de 14 dias habiles, segun
              los tiempos del emisor de la tarjeta.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">3. Cancelacion o No Aceptacion por el Restaurante</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              Si el restaurante no acepta el pedido en un plazo maximo de 5 minutos, el pedido se cancelara
              automaticamente y el importe sera reembolsado integramente al cliente.
            </p>
            <p className="text-[#5C4D43] leading-relaxed mt-3">
              El restaurante podra tambien cancelar un pedido aceptado en caso de fuerza mayor, falta de stock,
              imposibilidad de entrega en la zona indicada u otras circunstancias ajenas a su voluntad. En
              estos casos se procedera al reembolso integro del importe pagado.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">4. Reclamaciones por Pedido Incorrecto o Defectuoso</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              Si el pedido recibido no coincide con el solicitado, esta incompleto o presenta algun defecto de
              calidad, el cliente dispone de un plazo de <strong>2 horas</strong> desde la recepcion para
              presentar una reclamacion en:
            </p>
            <ul className="list-none pl-0 text-[#5C4D43] mt-3 space-y-1">
              <li>Email: <strong>Tajmahalsafernando@gmail.com</strong></li>
              <li>Telefono / WhatsApp: <strong>+34 602 704 745</strong></li>
            </ul>
            <p className="text-[#5C4D43] leading-relaxed mt-3">
              La reclamacion debera incluir el numero de pedido, una descripcion del problema y, a ser posible,
              fotografias. Tras verificar la incidencia, el restaurante ofrecera, segun el caso: (a) la
              reposicion del producto afectado, (b) un vale por valor equivalente, o (c) el reembolso total o
              parcial al mismo medio de pago.
            </p>
            <p className="text-[#5C4D43] leading-relaxed mt-3">
              Pasado el plazo de 2 horas, dada la naturaleza perecedera de los productos alimentarios y la
              imposibilidad de verificar su trazabilidad y conservacion, no se aceptaran reclamaciones de
              calidad ni de estado. Las reclamaciones por <strong>alergenos</strong> se rigen por lo dispuesto
              en la seccion 8 de los Terminos y Condiciones.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">5. Plazos de Reembolso</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              Los reembolsos aprobados se procesaran a traves del mismo medio de pago utilizado en la compra
              original. El tiempo que tarda en aparecer en la cuenta del cliente depende del banco emisor de
              la tarjeta, siendo habitualmente de entre 5 y 14 dias habiles.
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">6. Hojas de Reclamaciones</h2>
            <p className="text-[#5C4D43] leading-relaxed">
              Conforme a la normativa autonomica de defensa del consumidor de Andalucia, el restaurante
              dispone de hojas de reclamaciones oficiales a disposicion del cliente en el establecimiento
              fisico: Calle Real 109, San Fernando (Cadiz).
            </p>
            <p className="text-[#5C4D43] leading-relaxed mt-3">
              Asimismo, el cliente con la condicion de consumidor puede recurrir a la plataforma europea de
              Resolucion de Litigios en Linea:{' '}
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#C44536] underline">
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
          </section>

          <section className="bg-[#F5EFE6] rounded-2xl p-6 border border-[#E8DEC8]">
            <h2 className="font-serif text-xl font-semibold mb-3">7. Contacto</h2>
            <p className="text-[#5C4D43]">
              Talwinder Singh Kaur (empresaria autonoma) — Taj Mahal San Fernando<br />
              NIF: 78317925G<br />
              Calle Real 109, San Fernando, Cadiz 11100, España<br />
              Email: Tajmahalsafernando@gmail.com<br />
              Telefono: +34 602 704 745
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyPage;
